import React from "react";

import {
  PrimaryBlockType,
  primaryBlock,
  PrimaryBlockConfig,
  SecondaryBlockSize,
  TertiaryBlockSize,
  BlockTheme,
  getDefaultProps,
  Shared,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";
import { Variants } from "@kameleon-util/global-theme";
import { LayoutProps } from "../types/prop-types";
import defaults from "../defaults.json";

export type ContentCollectionItemType = {
  /** Place prop documentation here */
  title?: string;
  description?: string;
  primaryButtonText?: string;
  primaryButtonLink?: string;
  secondaryButtonText?: string;
  secondaryButtonLink?: string;
  image?: Shared.Props.MediaProp;
} & PrimaryBlockType<LayoutProps>;

/** ContentCollectionItem PrimaryCollection */
export const blockConfig: PrimaryBlockConfig = {
  secondaryBlockSize: SecondaryBlockSize.Large,
  tertiaryBlockSize: TertiaryBlockSize.Default,
  blockTheme: BlockTheme.light,
};

export const ContentCollectionItem = primaryBlock<ContentCollectionItemType>(
  blockConfig,
  ({
    title,
    description,
    primaryButtonText,
    primaryButtonLink,
    secondaryButtonText,
    secondaryButtonLink,
    image,
  }: ContentCollectionItemType) => (
    <Box className="primary-collection-content-collection-two-col-timeline-v1">
      <Box
        data-w-id="b6fa2246-64c0-bf9e-5e27-394625647ea8"
        className="layout352_item"
      >
        <Box className="layout352_left">
          <Variants.Heading as="h3" className="layout352_date-text">
            {title}
          </Variants.Heading>
        </Box>
        <Box
          id="w-node-b6fa2246-64c0-bf9e-5e27-394625647eac-910f14f5"
          className="layout352_centre"
        >
          <Variants.TimelineCircle className="layout352_circle" />
        </Box>
        <Box
          id="w-node-b6fa2246-64c0-bf9e-5e27-394625647eae-910f14f5"
          className="layout352_right"
        >
          <Box
            id="w-node-b6fa2246-64c0-bf9e-5e27-394625647eaf-910f14f5"
            className="margin-bottom margin-xlarge"
          >
            <Variants.ParagraphMedium>
              {description}
              <br />
            </Variants.ParagraphMedium>
            <Box className="margin-top margin-medium">
              {primaryButtonText && secondaryButtonText && (
                <Box className="button-group">
                  <Variants.LinkButtonSecondary
                    href={primaryButtonLink}
                    className="button is-secondary"
                  >
                    {primaryButtonText}
                  </Variants.LinkButtonSecondary>
                  <Variants.LinkButtonIcon
                    href={secondaryButtonLink}
                    className="button"
                  >
                    {secondaryButtonText}
                  </Variants.LinkButtonIcon>
                </Box>
              )}
            </Box>
          </Box>
          <Box className="layout352_image-wrapper">
            <Variants.Image src={image?.url} loading="lazy" alt={image?.alt} />
          </Box>
        </Box>
      </Box>
    </Box>
  )
);

const itemDefaults = {
  layoutProps: defaults.layoutProps,
  contentProps: defaults.contentProps.PrimaryBlocks[0] ?? {},
};
ContentCollectionItem.defaultProps =
  getDefaultProps<ContentCollectionItemType>(itemDefaults);
